<template>
  <div class="engery flex-row flex-justify-center flex-align-start">
    <div class="engery-index flex-column flex-justify-start flex-align-center">
      <div class="card-line flex-row flex-justify-start flex-align-start">
        <EngeryCard
          v-for="(item, index) in engeryCards" :key="index"
          :back-color="item.color"
          :card-title="item.title"
          :meter-num="item.num"
          :meter-value="item.value"
          :meter-fault="item.fault"
          :gap="item.gap">
        </EngeryCard>
      </div>
      <div class="card-line flex-row flex-justify-start flex-align-start">
        <ElectChart :gap="true" :elect="elect" />
        <WaterChart :gap="false" :water="water" />
      </div>
      <div class="card-line flex-row flex-justify-start flex-align-start">
        <FlowChart :gap="true" :flow="flow" />
        <ColdChart :gap="false" :cold="cold" />
      </div>
      <div class="card-line gap-bottom flex-row flex-justify-start flex-align-start">
        <ErrChart :gap="true" :error="error" />
        <ErrTab :gap="false" :errlogs="errlogs" />
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import EngeryCard from '@/views/Home/engery/EngeryCard.vue'
import ElectChart from '@/views/Home/engery/ElectChart.vue'
import WaterChart from '@/views/Home/engery/WaterChart.vue'
import FlowChart from '@/views/Home/engery/FlowChart.vue'
import ColdChart from '@/views/Home/engery/ColdChart.vue'
import ErrChart from '@/views/Home/engery/ErrChart.vue'
import ErrTab from '@/views/Home/engery/ErrTab.vue'
import {getEngerySataistic, getErrLogs} from '@/api/engery.js';

export default {
  name: 'EngeryIndex',
  data() {
    return{
      engeryCards: [
        {
          color: '#f6628b',
          title: '本年电量',
          num: `电表总数:`,
          value: `kW`,
          fault: `故障总数:`,
          gap: true
        },
        {
          color: '#32bafb',
          title: '本年水量',
          num: `水表总数:`,
          value: `吨`,
          fault: `故障总数:`,
          gap: true
        },
        {
          color: '#fbbe47',
          title: '本年流量',
          num: `流量计总数:`,
          value: `m³`,
          fault: `故障总数:`,
          gap: true
        },
        {
          color: '#6fc470',
          title: '本年时长',
          num: `冷气表总数:`,
          value: `时`,
          fault: `故障总数:`,
          gap: false
        }
      ],
      elect: {
        thiselect: [],
        lastelect: []
      },
      water: {
        thiswater: [],
        lastwater: []
      },
      flow: {
        thisflow: [],
        lastflow: []
      },
      cold: {
        thiscold: [],
        lastcold: []
      },
      error: {
        elect: [],
        water: [],
        flow: [],
        cold: []
      },
      errlogs: []
    }
  },
  components: {
    EngeryCard,
    ElectChart,
    WaterChart,
    FlowChart,
    ColdChart,
    ErrChart,
    ErrTab
  },
  async mounted() {
    const engeryRes = await getEngerySataistic()
    this.engeryCards = engeryRes.data.detail
    this.elect = engeryRes.data.elect
    this.water = engeryRes.data.water
    this.flow = engeryRes.data.flow
    this.cold = engeryRes.data.cold
    this.error = engeryRes.data.error
    const errs = getErrLogs()
    this.errlogs = errs.data.errlogs
  }
}
</script>
<style scoped>
.engery {
  width: 100%;
  height: 100%;
}
.engery-index {
  width: 99%;
}
.card-line {
  width: 100%;
  margin-top: 20px;
}
.gap-bottom {
  margin-bottom: 20px;
}
</style>
